import React from 'react';

import { RightSidebar } from "../../../_partials/Layout";
import { NotificationInterface } from "../../../../store/mine_craft/notificationsSlice";
import RowInfo from "../../../../componets/RowInfo";

const _SidebarShow = ({ notification }: { notification: NotificationInterface | undefined }) => {
  const renderDetails = () => {
    if(!notification) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={notification.id} />
          <RowInfo left='#SLUG' right={notification.slug} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
